import React, {Fragment, useEffect, useState} from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import {config} from "../../../config";
import {getLittleGenderName, getProprioByUID, getTypeName} from "../../../services/propriosService";
import { initVisite, getLastVisitesByHlo, refreshVisites, getIsForVisite } from "../../../services/visitesService";
import {getDateLightFromTimestamp} from "../../../services/utilities";
import useDuplicateVisite from '../../../services/useDuplicateVisite';
import {Badge, OverlayTrigger, Tooltip} from "react-bootstrap";
import ModaleVisite from "../../modal-visite";
import ModaleCopyDiffs from "../../modal-copy-diffs";
import useAutorisations from "../../../services/useAutorisations";
import "./location-item.scss";
import {getThemesByUid} from '../../../services/themeService';
import {dbAdd} from "../../../services/indexedDBService";

const LocationItem = ({ location, visiteuid, hide }) => {

    const history = useHistory();

    const [tooltipMessage, setTooltipMessage] = useState("Chargement...");

    const propsUids = location.props.split(',');
    const props = propsUids.map(propUid => getProprioByUID(propUid));
    const { canUpdateVisite } = useAutorisations();
    const { getDiffsAndCopy, saveCopy } = useDuplicateVisite();

    const [showVisite, setShowVisite] = useState(false);
    const [showDiffs, setShowDiffs] = useState(false);
    const [isloading, setIsloading] =  useState(false);
    const [lastVisite, setLastVisite] =  useState(null);
    const [nbThemes, setNbThemes] = useState(0);
    const [isThemeChecked, setIsThemeChecked] = useState(false);

    useEffect(() => {

        let isMounted = true;

        if(isMounted){
            getLastVisitesByHlo(location.loc_hlo).then(visite => {
                setLastVisite(visite);
            });
        }

        return ()=>{
            isMounted = false;
        }
    },[location]);

    useEffect(() => {
        if (!visiteuid) return;

        const loadTooltipMessage = async () => {
            try {
                const themes = await getThemesByUid(visiteuid);
                const count = themes.length;
                setNbThemes(count);

                if (count  === 0) {
                    setTooltipMessage("Aucun thème à dupliquer");
                } else {
                    setTooltipMessage(`Dupliquer aussi le${count  > 1 ? 's' : ''} ${count } thème${count  > 1 ? 's' : ''}`);
                }
            } catch (error) {
                setTooltipMessage("Erreur lors du chargement");
                setNbThemes(0);
            }
        };

        loadTooltipMessage();
    }, [visiteuid, getThemesByUid]);

    var date_visite = "Aucune";
    if(location.date_visite){
        date_visite = getDateLightFromTimestamp(location.date_visite);
    }

    const newVisite = () => {
        initVisite(location.loc_hlo);
        setShowVisite(true);
    }

    const duplicate = () => {
        setIsloading(true);
        getDiffsAndCopy(visiteuid, location.loc_hlo, location.type)
            .then(async (copy) => {
                if(copy.diffs.count){
                    setShowDiffs(copy);
                } else {
                    const finalUid = await doCopy(copy.visite);
                    // Si le checkbox est coché et qu'on a un UID final, dupliquer aussi les thèmes
                    if (isThemeChecked && finalUid) {
                        try {
                            const themes = await getThemesByUid(visiteuid);
                            for (const theme of themes) {
                                const themeCopy = {
                                    ...theme,
                                    uid: finalUid // UID final
                                };
                                await dbAdd('visits_content', themeCopy);
                            }
                            console.log(`${themes.length} thème(s) dupliqué(s)`);
                        } catch (error) {
                            console.error('Erreur lors de la duplication des thèmes:', error);
                        }
                    }

                    history.push(`/visit-update/${finalUid}`);
                }
                setIsloading(false);
            });
    }

    const doCopy = (visite) => {
        //console.log("visite.uid: " + visite.uid); //UID temporaire
        return new Promise((resolve) => {
            saveCopy(visite)
                .then(result => {
                    if(result) {
                        refreshVisites()
                            .then(() => {
                                //console.log("visite.uid: " + visite.uid);//UID final
                                if(hide) hide();
                                resolve(visite.uid); // Retourne l'UID final
                            });
                    } else {
                        resolve(null); // En cas d'échec
                    }
                });
        });
    }
    const cancelDuplicate = () => {
        setShowDiffs(null);
    }

    const tooltipEdit = (props) => (
        <Tooltip id="tooltip-editer-visite" {...props}>Modifier la dernière visite</Tooltip>
    );

    const tooltipRead = (props) => (
        <Tooltip id="tooltip-read-visite" {...props}>Consulter la dernière visite</Tooltip>
    );

    return(
        <div className={`location-item${isloading ? ' loading' : ''} `}>
            <div className="location-infos">
                <div className="location-hlo d-flex gap-2">
                    <div className="location-status">
                        {location.state === 'actif' ?
                            <Badge pill bg="success"><i className="icon icon-check"></i></Badge> :
                            <Badge pill bg="warning"><i className="icon icon-ios-close"></i></Badge>
                        }
                    </div>
                    <div>
                        <strong>{location.loc_hlo} / {location.agr}</strong>
                        {location.name && <span className="location-name d-block"><i>"{location.name}"</i></span>}
                        {location.nature && <span className="location-nature d-block">Nature : {location.nature}</span>}
                    </div>
                </div>
            </div>
            <div className="location-type">{config.group_visit[location.type].name} <br>
            </br>{location.capacity}<i className="icon icon-user-homme"></i>
        </div>
    <div className="location-date_visite">{date_visite}</div>
    <div className="location-contact">
                {props && props.map(prop => (prop) && 
                    <Fragment key={prop.uid}>
                        <span>{prop.hasOwnProperty('gender') && getLittleGenderName(prop.gender)} {prop.firstname} {prop.lastname} ({location.prop_type ? getTypeName(location.prop_type) : 'Propriétaire'})</span>
                        <br/>
                        {prop.is_pro == "1" && <><span className="badge-pro">Prof. {prop.company_name && <> {prop.company_name}</>}</span></>}
                    </Fragment>
                )}
            </div>
            <div className="location-commune">{location.commune} {location.geo_dep_id && `(${location.geo_dep_id})`}</div>
            <div className="location-actions">

                <div className="left-section">
                    {visiteuid ?
                        <>
                            <button className="btn btn-outline-success" onClick={duplicate}>Sélectioner</button>
                            <div className={`form-check form-switch visit-form-check`}>
                                <input className="form-check-input"
                                       type="checkbox"
                                       onChange={(e) => setIsThemeChecked(e.target.checked)}
                                       disabled={nbThemes === 0} />
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={<Tooltip className="custom-tooltip"> {tooltipMessage}</Tooltip>}
                                    container={document.body}
                                >
                                    <label className={`form-check-label d-flex gap-2`}>
                                        <span className="titre">Thématiques</span>
                                    </label>
                                </OverlayTrigger>
                            </div>
                        </>
                        :
                        <button className="btn btn-outline-success" onClick={newVisite}>Visiter</button>
                    }
                </div>

                <div class="right-section">
                    {lastVisite &&
                        <>
                            <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={tooltipRead}>
                            <Link to={`/visit/${lastVisite.uid}`} className="btn btn-outline-success" title="Dernière visite">
                                        <i className="icon icon-eye"></i>
                                    </Link>
                                </OverlayTrigger>

                                { (canUpdateVisite(lastVisite) && getIsForVisite(lastVisite)) &&
                                    <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={tooltipEdit}>
                                        <Link
                                            className={`btn btn-outline-info`}
                                            to={`/visit-update/${lastVisite.uid}`} title="Modifier cette visite">
                                            <i className="icon icon-pencil"></i>
                                        </Link>
                                    </OverlayTrigger>
                                }
                            </>
                        }
                    {showVisite && <ModaleVisite show={showVisite} loc_hlo={location.loc_hlo} onHide={() => setShowVisite(false)} />}
                    {showDiffs && <ModaleCopyDiffs show={showDiffs} data={showDiffs} onCancel={cancelDuplicate} onCopy={doCopy} />}
                </div>
            </div>
        </div>
    );
}

export default LocationItem;
